// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"132":"c37e3d97","354":"7f923baa","418":"244f283b"}[chunkId] + ".js";
};